export const containerWidth = 1330;
export const gap = 30;
export const columns = 12;
export const breakpoints = {
    sm: 500,
    md: 800,
    lg: 1100,
    xl: 1400,
};
